
import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../../../apiservice/apis";
const itemFamily = ["By Item", "By Group", "By Category"];
export const fetchPurchaseReturnRecord = createAsyncThunk(
  "purchaseReturnRecord/fetch",
  async ({ selectedFilterType, selectedRecordType, filters }, { rejectWithValue }) => {
    try {
      let url = "/purchase/get-purchase-return-record";
      if (selectedRecordType === "with item") {
        url = "/purchase/get-purchase-return-record-with-details";
      }
      if (
        selectedFilterType &&
        ["By Item", "By Tag", "By Group", "By Category"].includes(selectedFilterType)
      ) {
        url = "/purchase/get-purchase-return-details";
      }

      const payload = {
        selectedFilterType: selectedFilterType || null,
        selectedRecordType: selectedRecordType || null,
        locationId: selectedFilterType === "By Location" ? filters.locationId || null : null,
        supplierId: selectedFilterType === "By Supplier" ? filters.supplierId || null : null,
        // supplierId: selectedSupplier != null ? selectedSupplier.acc_id : null,
        employeeId: selectedFilterType === "By Employee" ? filters.employeeId || null : null,
        itemId: selectedFilterType === "By Item" ? filters.itemId || null : null,
        groupId: selectedFilterType === "By Group" ? filters.groupId || null : null,
        categoryId: selectedFilterType === "By Category" ? filters.categoryId || null : null,
        userId: selectedFilterType === "By User" ? filters.userId || null : null,
        serialNumber: selectedFilterType === "By Item Serial" ? filters.serialNumber || "" : "",
        tag_groupnameid: selectedFilterType === "By Tag" ? filters.tag_groupnameid || null : null,
        tagFeildNameid: selectedFilterType === "By Tag" ? filters.tagFeildNameid || null : null,
        fromDate: filters.fromDate || null,
        toDate: filters.toDate || null,
      };

      const res = await postData(url, payload);

      let mapped = [];
      if (selectedRecordType === "with item") {
        mapped = res.data.flatMap((purchaseReturn) =>
          purchaseReturn.details.map((item, idx) => {
            const total = Number(purchaseReturn.total_amount || 0);
            const paid = Number(
              purchaseReturn.paid_amount ||
              purchaseReturn.paid_total ||
              0
            );
            const due = Number(
              purchaseReturn.due_amount ||
              (total - paid)
            );

            return {
              id: `${purchaseReturn.pur_r_id}-${item.item_id}-${idx}`,
              pur_r_id: item.pur_r_id,
              vch_no: purchaseReturn.pur_r_voucher_no,
              date: purchaseReturn.created_date,
              supplier: purchaseReturn.acc_name,
              employee: purchaseReturn.employee_name,
              createdBy: purchaseReturn.full_name,
              mode: purchaseReturn.trans?.map((t) => t.to_acc_name).join(", ") || "",
              item: item.item_name,
              rate: Number(item.item_rate || 0).toFixed(2),
              discount: item.item_discount_per ? `${item.item_discount_per}%` : "",
              vat: item.item_tax_per ? `${item.item_tax_per}%` : "",
              qty: `${item.pur_r_qty} ${item.unit_name || ""}`,
              pur_r_qty: item.pur_r_qty,
              total: Number(item.item_total || 0).toFixed(2),

              // ✅ paid/due correctly mapped
              paid: paid.toFixed(2),
              due: due.toFixed(2),

              // Keep raw values for grand totals
              masterQty: Number(item.item_qty || 0),
              baseQty: Number(item.retail_qty || 0),

              unitDetails: `Total : Master U. Qty = ${item.pur_r_qty || 0}, Base U. Qty = ${item.pur_r_qty || 0}`,
            };
          })
        );
      } else if (itemFamily.includes(selectedFilterType)) {
        mapped = res.data.map((row) => ({
          id: row.sale_id,
          vch_no: row.pur_r_voucher_no,
          date: row.created_date,
          supplier: row.acc_name,
          createdBy: row.full_name,
          item_name: row.item_name,
          display_text: row.display_text || row.item_code,
          item_qty: Number(row.pur_r_qty || 0),
          item_rate: Number(row.pur_r_rate || 0),
          item_discount_per: Number(row.item_discount_per || 0),
          item_tax_per: Number(row.item_tax_per || 0),
          service: Number(row.other_service_cost || 0),
          item_total: Number(row.item_total || 0).toFixed(2),

          grpname: row.group_name,
          categoryName: row.category_name,
          tag_name: row.tag_name,
          field_name: row.field_name,

          unit_name: row.unit_name,
          unit_symbol: row.unit_symbol,
          base_unit_name: row.base_unit_name,
          retail_qty: Number(row.retail_qty || 0),
          conversion: Number(row.conversion || 1),

          qty_display: `${row.item_qty || 0} ${row.unit_symbol || ''}${(Number(row.conversion || 1) > 1) ? `, ${row.retail_qty || 0} ${row.base_unit_name || ''}` : ''}`,
          unitDetails: `Total : Master U. Qty = ${row.pur_r_qty || 0}, Base U. Qty = ${row.pur_r_qty || 0}`,
        }));
      } else {
        mapped = res.data.map((row) => {
          const total = Number(row.total_amount || 0);
          const paid = Number(
            row.paid_amount ||
            row.paid_total ||
            0
          );
          const due = Number(
            row.due_amount ||
            (total - paid)
          );

          return {
            id: row.pur_r_id,
            pur_r_id: row.pur_r_id,
            vch_no: row.pur_r_voucher_no,
            date: row.created_date,
            supplier: row.acc_name,
            employee: row.employee_name,
            createdBy: row.full_name,
            mode: row.trans?.map((t) => t.to_acc_name).join(", ") || "",
            subtotal: Number(row.sub_total || 0).toFixed(2),
            discount: Number(row.total_discount || 0).toFixed(2),
            vat: Number(row.total_tax || 0).toFixed(2),
            service: Number(row.other_service_cost || 0).toFixed(2),
            total: total.toFixed(2),
            paid: paid.toFixed(2),
            due: due.toFixed(2),
            tatmeen_sent_status: row.tatmeen_sent_status,
            sscc_code: row.sscc_code,
            tatmeen_message_id: row.tatmeen_message_id,
            tatmeen_retry_count: row.tatmeen_retry_count,
            tatmeen_failure_reason: row.tatmeen_failure_reason,
            tatmeen_sscc_status: row.tatmeen_sscc_status,
            tatmeen_manual_action_required:
              row.tatmeen_manual_action_required,
            tatmeen_last_retry_at:
              row.tatmeen_last_retry_at,
            cgst_amount: row.cgst_amount,
            sgst_amount: row.sgst_amount,
            igst_amount: row.igst_amount,
          };
        });
      }


      return mapped;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const checkPurchaseReturnDelete = createAsyncThunk(
  "purchaseReturnRecord/deleteCheck",
  async (pur_r_id, { rejectWithValue }) => {
    try {
      const res = await postData(
        "/purchase/purchase-return-delete-check",
        { pur_r_id }
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const deletePurchaseReturn = createAsyncThunk(
  "purchaseReturnRecord/delete",
  async (pur_r_id, { rejectWithValue }) => {
    try {
      const res = await postData(
        "/purchase/purchase-return-delete",
        { pur_r_id }
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const retryTatmeenPurchaseReturn = createAsyncThunk(
  "purchaseReturnRecord/retryTatmeen",
  async (pur_r_id, { rejectWithValue }) => {
    try {
      const res = await postData(
        "/purchase/purchase-return-manual-retry",
        { pur_r_id }
      );

      if (res?.data?.error || res?.error) {
        return rejectWithValue(
          res?.data?.message || res?.message || "Retry failed"
        );
      }

      return res?.data || res;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.response?.data || err.message
      );
    }
  }
);
